import { Col, Input, Label, Row } from "reactstrap";

import React from "react";

// Change #100301 - "ability to add contact people during the creation of
// customer ... equivalent to the PEOPLE tab within customer". The people are
// held here, outside the customer payload, and created against the new
// customer once it exists (see CreateEditCustomer). Editing a customer keeps
// using its People tab, which already does this properly.

export const newWizardPerson = (key) => ({
  key,
  FirstName: "",
  LastName: "",
  JobTitle: "",
  EmailAddress: "",
  TelephoneNumber: "",
});

// A row counts once it has a name; a blank row left over from "Add another"
// is ignored rather than refused.
export const wizardPersonHasName = (person) =>
  !!(person?.FirstName?.trim() || person?.LastName?.trim());

// The same body the People tab's AddEditPeople sends to contactperson/create.
export const wizardPersonPayload = (person, Customer_Id) => {
  const relationship = {
    Customer_Id,
    JobTitle: person.JobTitle?.trim() || "",
  };
  if (person.EmailAddress?.trim()) {
    relationship.contactpersonemailaddress_list = [
      {
        EmailAddress: person.EmailAddress.trim(),
        FlagEmailInvoiceTo: 0,
        FlagEmailInvoiceCc: 0,
        FlagEmailProformaInvoiceTo: 0,
        FlagEmailProformaInvoiceCc: 0,
        FlagDefault: "1",
        Notes: "",
      },
    ];
  }
  if (person.TelephoneNumber?.trim()) {
    relationship.contactpersontelephonenumber_list = [
      {
        TelephoneNumber: person.TelephoneNumber.trim(),
        FlagDefault: "1",
        Notes: "",
      },
    ];
  }
  return {
    FirstName: person.FirstName?.trim() || "",
    LastName: person.LastName?.trim() || "",
    Notes: "",
    Image: "",
    customertocontactpersonrelationship_list: [relationship],
  };
};

export function TabPeople({
  activeVerticalTab,
  handleCheckEachStep,
  isEditCustomer,
  wizardPeople,
  setWizardPeople,
}) {
  const updatePerson = (key, field, value) => {
    setWizardPeople((prev) =>
      prev.map((p) => (p.key === key ? { ...p, [field]: value } : p))
    );
  };
  const addPerson = () => {
    setWizardPeople((prev) => [
      ...prev,
      newWizardPerson(Math.max(0, ...prev.map((p) => p.key)) + 1),
    ]);
  };
  const removePerson = (key) => {
    setWizardPeople((prev) => prev.filter((p) => p.key !== key));
  };

  return (
    <>
      <div>
        <h5>People</h5>
        <p className="text-muted mb-0">
          The contacts at this customer - the same as the People tab once the
          customer exists. Optional; skip this step if there is nobody to add
          yet.
        </p>
      </div>

      {isEditCustomer ? (
        <div className="alert alert-info mt-3 mb-0">
          People on an existing customer are managed from the customer's{" "}
          <strong>People</strong> tab.
        </div>
      ) : (
        <>
          {wizardPeople.map((person, index) => (
            <div key={person.key} className="border rounded p-3 mt-3">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <span className="fw-medium">Person {index + 1}</span>
                <button
                  type="button"
                  className="btn btn-sm btn-ghost-danger"
                  onClick={() => removePerson(person.key)}
                  title="Remove this person"
                >
                  <i className="ri-delete-bin-line align-bottom"></i>
                </button>
              </div>
              <Row className="g-2">
                <Col md={6}>
                  <Label className="mb-1">First Name</Label>
                  <Input
                    type="text"
                    value={person.FirstName}
                    onChange={(e) =>
                      updatePerson(person.key, "FirstName", e.target.value)
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label className="mb-1">Last Name</Label>
                  <Input
                    type="text"
                    value={person.LastName}
                    onChange={(e) =>
                      updatePerson(person.key, "LastName", e.target.value)
                    }
                  />
                </Col>
                <Col md={12}>
                  <Label className="mb-1">Job Title</Label>
                  <Input
                    type="text"
                    value={person.JobTitle}
                    onChange={(e) =>
                      updatePerson(person.key, "JobTitle", e.target.value)
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label className="mb-1">Email Address</Label>
                  <Input
                    type="email"
                    value={person.EmailAddress}
                    onChange={(e) =>
                      updatePerson(person.key, "EmailAddress", e.target.value)
                    }
                  />
                </Col>
                <Col md={6}>
                  <Label className="mb-1">Telephone Number</Label>
                  <Input
                    type="tel"
                    value={person.TelephoneNumber}
                    onChange={(e) =>
                      updatePerson(
                        person.key,
                        "TelephoneNumber",
                        e.target.value
                      )
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}

          <button
            type="button"
            className="btn btn-soft-primary btn-sm mt-3"
            onClick={addPerson}
          >
            <i className="ri-user-add-line align-bottom me-1"></i>
            {wizardPeople.length ? "Add another person" : "Add a person"}
          </button>
        </>
      )}

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => {
            handleCheckEachStep(activeVerticalTab - 1);
          }}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
          Contact Information
        </button>
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={() => {
            handleCheckEachStep(activeVerticalTab + 1);
          }}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Acquisition Channel
        </button>
      </div>
    </>
  );
}
